<template>
 <body>

  <!-- header for tv START -->
  <div class="header header-tv">

    <!-- col-1 start -->
    <div class="col-1">

    <!-- start logo tv -->
      <div class="leftcol-banner logoTv">
        <img src="@/assets/images/banner-1.svg" alt="" />
      </div>
    <!-- stop logo tv -->

    </div>
    <!-- col-1 stop -->

    <!-- col-2 start -->
    <div class="col-2">

      <!-- jackpot start -->
      <div class="jackpotBox" v-if="$store.state.jackpotlast">
        <img src="@/assets/images/jackpot.svg" alt="" />
        <div class="jackpotNumber" v-if="$store.state.jackpot"> {{$store.state.jackpotlast.GameID != $store.state.game.GameID ? $store.state.jackpot.Amount.toFixed(2) : $store.state.jackpot.Amount.toFixed(2) == 0 ? $store.state.jackpotlast.Amount.toFixed(2) : $store.state.jackpot.Amount.toFixed(2)}}</div>
      </div>
      <!-- jackpot stop -->

    </div>
    <!-- col-2 stop -->

    <!-- col-1 start -->
    <div class="col-1">

      <div class="start" style="color: red">LIVE</div>

     <!-- counterTime-v2 start -->
      <div class="counterTime counterTime-v2" v-on="countDownTimer()" v-if="game">
        <i>{{game.time.min > 9 ? "" : game.time.min != "FT" ? '0' : ""}}{{game.time.min}}{{game.time.min == "FT" ? "" : "'"}}</i>
      </div>
      <!-- counterTime-v2 stop -->

    </div>
    <!-- col-1 stop -->

  </div>
  <!-- header for tv STOP -->

  <!-- main START -->
  <div class="main">

    <div class="tab9-box">

      <table class="tab9-table" v-if="$store.state.game">

        <tr>
          <th>
            <div class="league-weektv">
              <div class="leaguetv" v-if="$store.state.game">
                <div>{{$t('league')}}</div>
                <div>{{$store.state.game.League}}</div>
              </div>

              <div class="weektv" v-if="$store.state.game">
                <div>{{$t('week')}}</div>
                <div>{{$store.state.game.Week}}</div>
              </div>
            </div>
          </th>
          <th>{{$t('winner')}}</th>
          <th>{{$t('cors')}}</th>
          <th colspan="2">{{$t('dblc')}}</th>
          <th>{{$t('gng')}}</th>
          <th>{{$t('tg')}}</th>
          <th>{{$t('ov')}}/{{$t('un')}}1.5</th>
          <th>{{$t('ov')}}/{{$t('un')}}2.5</th>
          <th>{{$t('ov')}}/{{$t('un')}}3.5</th>
          <th>{{$t('ov')}}/{{$t('un')}}4.5</th>
        </tr>

        <tr class="trSeparator">
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>

        <!-- tr start repeat -->
        <tr class="trBg-1">
          <td  :class="classGet(0, 'teams')">
            <div>
              <span>1</span>
              <span><img :src="getimg($store.state.game.Match[0].HomeTeam)" alt=""></span>
              <span :class="whoscored(0, 0)">{{getteams($store.state.game.Match[0].HomeTeam)}}</span>
              <span v-if="$store.state.gameresult">{{results[0].Result}}</span>
              <span :class="whoscored(0, 2)">{{getteams($store.state.game.Match[0].AwayTeam)}}</span>
              <span><img :src="getimg($store.state.game.Match[0].AwayTeam)" alt=""></span>
            </div>
          </td>
          <td :class="classGet(0, 'win')" v-if="$store.state.gameresult">
            <p>{{getbet(results[0].Result, "Main", 0).bet}}</p>
            <p>{{getbet(results[0].Result, "Main", 0).name}}</p>
          </td>
          <td :class="classGet(0, 'win')" v-if="$store.state.gameresult">
            <p>{{$store.state.game.Match[0].Odds[results[0].Result]}}</p>
            <p>{{results[0].Result}}</p>
          </td>
          <td :class="classGet(0, 'win')" v-if="$store.state.gameresult">
            <p>{{getbet(results[0].Result, "Double", 0).bet}}</p>
            <p>{{getbet(results[0].Result, "Double", 0).name}}</p>
          </td>
          <td :class="classGet(0, 'win')" v-if="$store.state.gameresult">
            <p>{{getbet(results[0].Result, "Double", 0).bet2}}</p>
            <p>{{getbet(results[0].Result, "Double", 0).name2}}</p>
          </td>
          <td :class="getClass(getbet(results[0].Result, 'GGNG', 0).class)" v-if="$store.state.gameresult">
            <p>{{getbet(results[0].Result, "GGNG", 0).bet}}</p>
            <p>{{getbet(results[0].Result, "GGNG", 0).name}}</p>
          </td>
          <td :class="classGet(0, 'goals')" v-if="$store.state.gameresult">
            <p>{{getbet(results[0].Result, "GOALS", 0).bet}}</p>
            <p>{{getbet(results[0].Result, "GOALS", 0).name}}</p>
          </td>
          <td :class="getClass(getbet(results[0].Result, '1.5', 0).class)" v-if="$store.state.gameresult">
            <p>{{getbet(results[0].Result, 1.5, 0).bet}}</p>
            <p>{{getbet(results[0].Result, 1.5, 0).name}}</p>
          </td>
          <td :class="getClass(getbet(results[0].Result, '2.5', 0).class)" v-if="$store.state.gameresult">
            <p>{{getbet(results[0].Result, 2.5, 0).bet}}</p>
            <p>{{getbet(results[0].Result, 2.5, 0).name}}</p>
          </td>
          <td :class="getClass(getbet(results[0].Result, '3.5', 0).class)" v-if="$store.state.gameresult">
            <p>{{getbet(results[0].Result, 3.5, 0).bet}}</p>
            <p>{{getbet(results[0].Result, 3.5, 0).name}}</p>
          </td>
          <td :class="getClass(getbet(results[0].Result, '4.5', 0).class)" v-if="$store.state.gameresult">
            <p>{{getbet(results[0].Result, 4.5, 0).bet}}</p>
            <p>{{getbet(results[0].Result, 4.5, 0).name}}</p>
          </td>
        </tr>
        <tr class="trSeparator-2">
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <!-- tr stop repeat -->

        <tr class="trBg-2">
          <td  :class="classGet(1, 'teams')">
            <div>
              <span>2</span>
              <span><img :src="getimg($store.state.game.Match[1].HomeTeam)" alt=""></span>
              <span :class="whoscored(1, 0)">{{getteams($store.state.game.Match[1].HomeTeam)}}</span>
              <span v-if="$store.state.gameresult">{{results[1].Result}}</span>
              <span :class="whoscored(1, 2)">{{getteams($store.state.game.Match[1].AwayTeam)}}</span>
              <span><img :src="getimg($store.state.game.Match[1].AwayTeam)" alt=""></span>
            </div>
          </td>
          <td :class="classGet(1, 'win')" v-if="$store.state.gameresult">
            <p>{{getbet(results[1].Result, "Main", 1).bet}}</p>
            <p>{{getbet(results[1].Result, "Main", 1).name}}</p>
          </td>
          <td :class="classGet(1, 'win')" v-if="$store.state.gameresult">
            <p>{{$store.state.game.Match[1].Odds[results[1].Result]}}</p>
            <p>{{results[1].Result}}</p>
          </td>
          <td :class="classGet(1, 'win')" v-if="$store.state.gameresult">
            <p>{{getbet(results[1].Result, "Double", 1).bet}}</p>
            <p>{{getbet(results[1].Result, "Double", 1).name}}</p>
          </td>
          <td :class="classGet(1, 'win')" v-if="$store.state.gameresult">
            <p>{{getbet(results[1].Result, "Double", 1).bet2}}</p>
            <p>{{getbet(results[1].Result, "Double", 1).name2}}</p>
          </td>
          <td :class="getClass(getbet(results[1].Result, 'GGNG', 1).class)" v-if="$store.state.gameresult">
            <p>{{getbet(results[1].Result, "GGNG", 1).bet}}</p>
            <p>{{getbet(results[1].Result, "GGNG", 1).name}}</p>
          </td>
          <td :class="classGet(1, 'win')" v-if="$store.state.gameresult">
            <p>{{getbet(results[1].Result, "GOALS", 1).bet}}</p>
            <p>{{getbet(results[1].Result, "GOALS", 1).name}}</p>
          </td>
          <td :class="getClass(getbet(results[1].Result, '1.5', 1).class)" v-if="$store.state.gameresult">
            <p>{{getbet(results[1].Result, 1.5, 1).bet}}</p>
            <p>{{getbet(results[1].Result, 1.5, 1).name}}</p>
          </td>
          <td :class="getClass(getbet(results[1].Result, '2.5', 1).class)" v-if="$store.state.gameresult">
            <p>{{getbet(results[1].Result, 2.5, 1).bet}}</p>
            <p>{{getbet(results[1].Result, 2.5, 1).name}}</p>
          </td>
          <td :class="getClass(getbet(results[1].Result, '3.5', 1).class)" v-if="$store.state.gameresult">
            <p>{{getbet(results[1].Result, 3.5, 1).bet}}</p>
            <p>{{getbet(results[1].Result, 3.5, 1).name}}</p>
          </td>
          <td :class="getClass(getbet(results[1].Result, '4.5', 1).class)" v-if="$store.state.gameresult">
            <p>{{getbet(results[1].Result, 4.5, 1).bet}}</p>
            <p>{{getbet(results[1].Result, 4.5, 1).name}}</p>
          </td>
        </tr>
        <tr class="trSeparator-2">
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>


        <tr class="trBg-1">
          <td  :class="classGet(2, 'teams')">
            <div>
              <span>3</span>
              <span><img :src="getimg($store.state.game.Match[2].HomeTeam)" alt=""></span>
              <span :class="whoscored(1, 0)">{{getteams($store.state.game.Match[2].HomeTeam)}}</span>
              <span v-if="$store.state.gameresult">{{results[2].Result}}</span>
              <span :class="whoscored(2, 2)">{{getteams($store.state.game.Match[2].AwayTeam)}}</span>
              <span><img :src="getimg($store.state.game.Match[2].AwayTeam)" alt=""></span>
            </div>
          </td>
          <td :class="classGet(2, 'win')" v-if="$store.state.gameresult">
            <p>{{getbet(results[2].Result, "Main", 2).bet}}</p>
            <p>{{getbet(results[2].Result, "Main", 2).name}}</p>
          </td>
          <td :class="classGet(2, 'win')" v-if="$store.state.gameresult">
            <p>{{$store.state.game.Match[2].Odds[results[2].Result]}}</p>
            <p>{{results[2].Result}}</p>
          </td>
          <td :class="classGet(2, 'win')" v-if="$store.state.gameresult">
            <p>{{getbet(results[2].Result, "Double", 2).bet}}</p>
            <p>{{getbet(results[2].Result, "Double", 2).name}}</p>
          </td>
          <td :class="classGet(2, 'win')" v-if="$store.state.gameresult">
            <p>{{getbet(results[2].Result, "Double", 2).bet2}}</p>
            <p>{{getbet(results[2].Result, "Double", 2).name2}}</p>
          </td>
          <td :class="getClass(getbet(results[2].Result, 'GGNG', 2).class)" v-if="$store.state.gameresult">
            <p>{{getbet(results[2].Result, "GGNG", 2).bet}}</p>
            <p>{{getbet(results[2].Result, "GGNG", 2).name}}</p>
          </td>
          <td :class="classGet(2, 'win')" v-if="$store.state.gameresult">
            <p>{{getbet(results[2].Result, "GOALS", 2).bet}}</p>
            <p>{{getbet(results[2].Result, "GOALS", 2).name}}</p>
          </td>
          <td :class="getClass(getbet(results[2].Result, '1.5', 2).class)" v-if="$store.state.gameresult">
            <p>{{getbet(results[2].Result, 1.5, 2).bet}}</p>
            <p>{{getbet(results[2].Result, 1.5, 2).name}}</p>
          </td>
          <td :class="getClass(getbet(results[2].Result, '2.5', 2).class)" v-if="$store.state.gameresult">
            <p>{{getbet(results[2].Result, 2.5, 2).bet}}</p>
            <p>{{getbet(results[2].Result, 2.5, 2).name}}</p>
          </td>
          <td :class="getClass(getbet(results[2].Result, '3.5', 2).class)" v-if="$store.state.gameresult">
            <p>{{getbet(results[2].Result, 3.5, 2).bet}}</p>
            <p>{{getbet(results[2].Result, 3.5, 2).name}}</p>
          </td>
          <td :class="getClass(getbet(results[2].Result, '4.5', 2).class)" v-if="$store.state.gameresult">
            <p>{{getbet(results[2].Result, 4.5, 2).bet}}</p>
            <p>{{getbet(results[2].Result, 4.5, 2).name}}</p>
          </td>
        </tr>
        <tr class="trSeparator-2">
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>

        <tr class="trBg-2">
          <td  :class="classGet(3, 'teams')">
            <div>
              <span>4</span>
              <span><img :src="getimg($store.state.game.Match[3].HomeTeam)" alt=""></span>
              <span :class="whoscored(3, 0)">{{getteams($store.state.game.Match[3].HomeTeam)}}</span>
              <span v-if="$store.state.gameresult">{{results[3].Result}}</span>
              <span :class="whoscored(3, 2)">{{getteams($store.state.game.Match[3].AwayTeam)}}</span>
              <span><img :src="getimg($store.state.game.Match[3].AwayTeam)" alt=""></span>
            </div>
          </td>
          <td :class="classGet(3, 'win')" v-if="$store.state.gameresult">
            <p>{{getbet(results[3].Result, "Main", 3).bet}}</p>
            <p>{{getbet(results[3].Result, "Main", 3).name}}</p>
          </td>
          <td :class="classGet(3, 'win')" v-if="$store.state.gameresult">
            <p>{{$store.state.game.Match[3].Odds[results[3].Result]}}</p>
            <p>{{results[3].Result}}</p>
          </td>
          <td :class="classGet(3, 'win')" v-if="$store.state.gameresult">
            <p>{{getbet(results[3].Result, "Double", 3).bet}}</p>
            <p>{{getbet(results[3].Result, "Double", 3).name}}</p>
          </td>
          <td :class="classGet(3, 'win')" v-if="$store.state.gameresult">
            <p>{{getbet(results[3].Result, "Double", 3).bet2}}</p>
            <p>{{getbet(results[3].Result, "Double", 3).name2}}</p>
          </td>
          <td :class="getClass(getbet(results[3].Result, 'GGNG', 3).class)" v-if="$store.state.gameresult">
            <p>{{getbet(results[3].Result, "GGNG", 3).bet}}</p>
            <p>{{getbet(results[3].Result, "GGNG", 3).name}}</p>
          </td>
          <td :class="classGet(3, 'win')" v-if="$store.state.gameresult">
            <p>{{getbet(results[3].Result, "GOALS", 3).bet}}</p>
            <p>{{getbet(results[3].Result, "GOALS", 3).name}}</p>
          </td>
          <td :class="getClass(getbet(results[3].Result, '1.5', 3).class)" v-if="$store.state.gameresult">
            <p>{{getbet(results[3].Result, 1.5, 3).bet}}</p>
            <p>{{getbet(results[3].Result, 1.5, 3).name}}</p>
          </td>
          <td :class="getClass(getbet(results[3].Result, '2.5', 3).class)" v-if="$store.state.gameresult">
            <p>{{getbet(results[3].Result, 2.5, 3).bet}}</p>
            <p>{{getbet(results[3].Result, 2.5, 3).name}}</p>
          </td>
          <td :class="getClass(getbet(results[3].Result, '3.5', 3).class)" v-if="$store.state.gameresult">
            <p>{{getbet(results[3].Result, 3.5, 3).bet}}</p>
            <p>{{getbet(results[3].Result, 3.5, 3).name}}</p>
          </td>
          <td :class="getClass(getbet(results[3].Result, '4.5', 3).class)" v-if="$store.state.gameresult">
            <p>{{getbet(results[3].Result, 4.5, 3).bet}}</p>
            <p>{{getbet(results[3].Result, 4.5, 3).name}}</p>
          </td>
        </tr>
        <tr class="trSeparator-2">
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>

        <tr class="trBg-1">
          <td  :class="classGet(4, 'teams')">
            <div>
              <span>5</span>
              <span><img :src="getimg($store.state.game.Match[4].HomeTeam)" alt=""></span>
              <span :class="whoscored(4, 0)">{{getteams($store.state.game.Match[4].HomeTeam)}}</span>
              <span v-if="$store.state.gameresult">{{results[4].Result}}</span>
              <span :class="whoscored(4, 2)">{{getteams($store.state.game.Match[4].AwayTeam)}}</span>
              <span><img :src="getimg($store.state.game.Match[4].AwayTeam)" alt=""></span>
            </div>
          </td>
          <td :class="classGet(4, 'win')" v-if="$store.state.gameresult">
            <p>{{getbet(results[4].Result, "Main", 4).bet}}</p>
            <p>{{getbet(results[4].Result, "Main", 4).name}}</p>
          </td>
          <td :class="classGet(4, 'win')" v-if="$store.state.gameresult">
            <p>{{$store.state.game.Match[4].Odds[results[4].Result]}}</p>
            <p>{{results[4].Result}}</p>
          </td>
          <td :class="classGet(4, 'win')" v-if="$store.state.gameresult">
            <p>{{getbet(results[4].Result, "Double", 4).bet}}</p>
            <p>{{getbet(results[4].Result, "Double", 4).name}}</p>
          </td>
          <td :class="classGet(4, 'win')" v-if="$store.state.gameresult">
            <p>{{getbet(results[4].Result, "Double", 4).bet2}}</p>
            <p>{{getbet(results[4].Result, "Double", 4).name2}}</p>
          </td>
          <td :class="getClass(getbet(results[4].Result, 'GGNG', 4).class)" v-if="$store.state.gameresult">
            <p>{{getbet(results[4].Result, "GGNG", 4).bet}}</p>
            <p>{{getbet(results[4].Result, "GGNG", 4).name}}</p>
          </td>
          <td :class="classGet(4, 'win')" v-if="$store.state.gameresult">
            <p>{{getbet(results[4].Result, "GOALS", 4).bet}}</p>
            <p>{{getbet(results[4].Result, "GOALS", 4).name}}</p>
          </td>
          <td :class="getClass(getbet(results[4].Result, '1.5', 4).class)" v-if="$store.state.gameresult">
            <p>{{getbet(results[4].Result, 1.5, 4).bet}}</p>
            <p>{{getbet(results[4].Result, 1.5, 4).name}}</p>
          </td>
          <td :class="getClass(getbet(results[4].Result, '2.5', 4).class)" v-if="$store.state.gameresult">
            <p>{{getbet(results[4].Result, 2.5, 4).bet}}</p>
            <p>{{getbet(results[4].Result, 2.5, 4).name}}</p>
          </td>
          <td :class="getClass(getbet(results[4].Result, '3.5', 4).class)" v-if="$store.state.gameresult">
            <p>{{getbet(results[4].Result, 3.5, 4).bet}}</p>
            <p>{{getbet(results[4].Result, 3.5, 4).name}}</p>
          </td>
          <td :class="getClass(getbet(results[4].Result, '4.5', 4).class)" v-if="$store.state.gameresult">
            <p>{{getbet(results[4].Result, 4.5, 4).bet}}</p>
            <p>{{getbet(results[4].Result, 4.5, 4).name}}</p>
          </td>
        </tr>
        <tr class="trSeparator-2">
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>

        <tr class="trBg-2">
          <td  :class="classGet(5, 'teams')">
            <div>
              <span>6</span>
              <span><img :src="getimg($store.state.game.Match[5].HomeTeam)" alt=""></span>
              <span :class="whoscored(5, 0)">{{getteams($store.state.game.Match[5].HomeTeam)}}</span>
              <span v-if="$store.state.gameresult">{{results[5].Result}}</span>
              <span :class="whoscored(5, 2)">{{getteams($store.state.game.Match[5].AwayTeam)}}</span>
              <span><img :src="getimg($store.state.game.Match[5].AwayTeam)" alt=""></span>
            </div>
          </td>
          <td :class="classGet(5, 'win')" v-if="$store.state.gameresult">
            <p>{{getbet(results[5].Result, "Main", 5).bet}}</p>
            <p>{{getbet(results[5].Result, "Main", 5).name}}</p>
          </td>
          <td :class="classGet(5, 'win')" v-if="$store.state.gameresult">
            <p>{{$store.state.game.Match[5].Odds[results[5].Result]}}</p>
            <p>{{results[5].Result}}</p>
          </td>
          <td :class="classGet(5, 'win')" v-if="$store.state.gameresult">
            <p>{{getbet(results[5].Result, "Double", 5).bet}}</p>
            <p>{{getbet(results[5].Result, "Double", 5).name}}</p>
          </td>
          <td :class="classGet(5, 'win')" v-if="$store.state.gameresult">
            <p>{{getbet(results[5].Result, "Double", 5).bet2}}</p>
            <p>{{getbet(results[5].Result, "Double", 5).name2}}</p>
          </td>
          <td :class="getClass(getbet(results[5].Result, 'GGNG', 5).class)" v-if="$store.state.gameresult">
            <p>{{getbet(results[5].Result, "GGNG", 5).bet}}</p>
            <p>{{getbet(results[5].Result, "GGNG", 5).name}}</p>
          </td>
          <td :class="classGet(5, 'win')" v-if="$store.state.gameresult">
            <p>{{getbet(results[5].Result, "GOALS", 5).bet}}</p>
            <p>{{getbet(results[5].Result, "GOALS", 5).name}}</p>
          </td>
          <td :class="getClass(getbet(results[5].Result, '1.5', 5).class)" v-if="$store.state.gameresult">
            <p>{{getbet(results[5].Result, 1.5, 5).bet}}</p>
            <p>{{getbet(results[5].Result, 1.5, 5).name}}</p>
          </td>
          <td :class="getClass(getbet(results[5].Result, '2.5', 5).class)" v-if="$store.state.gameresult">
            <p>{{getbet(results[5].Result, 2.5, 5).bet}}</p>
            <p>{{getbet(results[5].Result, 2.5, 5).name}}</p>
          </td>
          <td :class="getClass(getbet(results[5].Result, '3.5', 5).class)" v-if="$store.state.gameresult">
            <p>{{getbet(results[5].Result, 3.5, 5).bet}}</p>
            <p>{{getbet(results[5].Result, 3.5, 5).name}}</p>
          </td>
          <td :class="getClass(getbet(results[5].Result, '4.5', 5).class)" v-if="$store.state.gameresult">
            <p>{{getbet(results[5].Result, 4.5, 5).bet}}</p>
            <p>{{getbet(results[5].Result, 4.5, 5).name}}</p>
          </td>
        </tr>
        <tr class="trSeparator-2">
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>

        <tr class="trBg-1">
          <td  :class="classGet(6, 'teams')">
            <div>
              <span>7</span>
              <span><img :src="getimg($store.state.game.Match[6].HomeTeam)" alt=""></span>
              <span :class="whoscored(6, 0)">{{getteams($store.state.game.Match[6].HomeTeam)}}</span>
              <span v-if="$store.state.gameresult">{{results[6].Result}}</span>
              <span :class="whoscored(6, 2)">{{getteams($store.state.game.Match[6].AwayTeam)}}</span>
              <span><img :src="getimg($store.state.game.Match[6].AwayTeam)" alt=""></span>
            </div>
          </td>
          <td :class="classGet(6, 'win')" v-if="$store.state.gameresult">
            <p>{{getbet(results[6].Result, "Main", 6).bet}}</p>
            <p>{{getbet(results[6].Result, "Main", 6).name}}</p>
          </td>
          <td :class="classGet(6, 'win')" v-if="$store.state.gameresult">
            <p>{{$store.state.game.Match[6].Odds[results[6].Result]}}</p>
            <p>{{results[6].Result}}</p>
          </td>
          <td :class="classGet(6, 'win')" v-if="$store.state.gameresult">
            <p>{{getbet(results[6].Result, "Double", 6).bet}}</p>
            <p>{{getbet(results[6].Result, "Double", 6).name}}</p>
          </td>
          <td :class="classGet(6, 'win')" v-if="$store.state.gameresult">
            <p>{{getbet(results[6].Result, "Double", 6).bet2}}</p>
            <p>{{getbet(results[6].Result, "Double", 6).name2}}</p>
          </td>
          <td :class="getClass(getbet(results[6].Result, 'GGNG', 6).class)" v-if="$store.state.gameresult">
            <p>{{getbet(results[6].Result, "GGNG", 6).bet}}</p>
            <p>{{getbet(results[6].Result, "GGNG", 6).name}}</p>
          </td>
          <td :class="classGet(6, 'win')" v-if="$store.state.gameresult">
            <p>{{getbet(results[6].Result, "GOALS", 6).bet}}</p>
            <p>{{getbet(results[6].Result, "GOALS", 6).name}}</p>
          </td>
          <td :class="getClass(getbet(results[6].Result, '1.5', 6).class)" v-if="$store.state.gameresult">
            <p>{{getbet(results[6].Result, 1.5, 6).bet}}</p>
            <p>{{getbet(results[6].Result, 1.5, 6).name}}</p>
          </td>
          <td :class="getClass(getbet(results[6].Result, '2.5', 6).class)" v-if="$store.state.gameresult">
            <p>{{getbet(results[6].Result, 2.5, 6).bet}}</p>
            <p>{{getbet(results[6].Result, 2.5, 6).name}}</p>
          </td>
          <td :class="getClass(getbet(results[6].Result, '3.5', 6).class)" v-if="$store.state.gameresult">
            <p>{{getbet(results[6].Result, 3.5, 6).bet}}</p>
            <p>{{getbet(results[6].Result, 3.5, 6).name}}</p>
          </td>
          <td :class="getClass(getbet(results[6].Result, '4.5', 6).class)" v-if="$store.state.gameresult">
            <p>{{getbet(results[6].Result, 4.5, 6).bet}}</p>
            <p>{{getbet(results[6].Result, 4.5, 6).name}}</p>
          </td>
        </tr>
        <tr class="trSeparator-2">
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>

        <tr class="trBg-2">
          <td  :class="classGet(7 , 'teams')">
            <div>
              <span>8</span>
              <span><img :src="getimg($store.state.game.Match[7].HomeTeam)" alt=""></span>
              <span :class="whoscored(7, 0)">{{getteams($store.state.game.Match[7].HomeTeam)}}</span>
              <span v-if="$store.state.gameresult">{{results[7].Result}}</span>
              <span :class="whoscored(7, 2)">{{getteams($store.state.game.Match[7].AwayTeam)}}</span>
              <span><img :src="getimg($store.state.game.Match[7].AwayTeam)" alt=""></span>
            </div>
          </td>
          <td :class="classGet(7 , 'win')" v-if="$store.state.gameresult">
            <p>{{getbet(results[7].Result, "Main", 7).bet}}</p>
            <p>{{getbet(results[7].Result, "Main", 7).name}}</p>
          </td>
          <td :class="classGet(7 , 'win')" v-if="$store.state.gameresult">
            <p>{{$store.state.game.Match[7].Odds[results[7].Result]}}</p>
            <p>{{results[7].Result}}</p>
          </td>
          <td :class="classGet(7 , 'win')" v-if="$store.state.gameresult">
            <p>{{getbet(results[7].Result, "Double", 7).bet}}</p>
            <p>{{getbet(results[7].Result, "Double", 7).name}}</p>
          </td>
          <td :class="classGet(7 , 'win')" v-if="$store.state.gameresult">
            <p>{{getbet(results[7].Result, "Double", 7).bet2}}</p>
            <p>{{getbet(results[7].Result, "Double", 7).name2}}</p>
          </td>
          <td :class="getClass(getbet(results[7].Result, 'GGNG', 7).class)" v-if="$store.state.gameresult">
            <p>{{getbet(results[7].Result, "GGNG", 7).bet}}</p>
            <p>{{getbet(results[7].Result, "GGNG", 7).name}}</p>
          </td>
          <td :class="classGet(7 , 'win')" v-if="$store.state.gameresult">
            <p>{{getbet(results[7].Result, "GOALS", 7).bet}}</p>
            <p>{{getbet(results[7].Result, "GOALS", 7).name}}</p>
          </td>
          <td :class="getClass(getbet(results[7].Result, '1.5', 7).class)" v-if="$store.state.gameresult">
            <p>{{getbet(results[7].Result, 1.5, 7).bet}}</p>
            <p>{{getbet(results[7].Result, 1.5, 7).name}}</p>
          </td>
          <td :class="getClass(getbet(results[7].Result, '2.5', 7).class)" v-if="$store.state.gameresult">
            <p>{{getbet(results[7].Result, 2.5, 7).bet}}</p>
            <p>{{getbet(results[7].Result, 2.5, 7).name}}</p>
          </td>
          <td :class="getClass(getbet(results[7].Result, '3.5', 7).class)" v-if="$store.state.gameresult">
            <p>{{getbet(results[7].Result, 3.5, 7).bet}}</p>
            <p>{{getbet(results[7].Result, 3.5, 7).name}}</p>
          </td>
          <td :class="getClass(getbet(results[7].Result, '4.5', 7).class)" v-if="$store.state.gameresult">
            <p>{{getbet(results[7].Result, 4.5, 7).bet}}</p>
            <p>{{getbet(results[7].Result, 4.5, 7).name}}</p>
          </td>
        </tr>
        <tr class="trSeparator-2">
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>

        <tr class="trBg-1">
          <td  :class="classGet(8 , 'teams')">
            <div>
              <span>9</span>
              <span><img :src="getimg($store.state.game.Match[8].HomeTeam)" alt=""></span>
              <span :class="whoscored(8, 0)">{{getteams($store.state.game.Match[8].HomeTeam)}}</span>
              <span v-if="$store.state.gameresult">{{results[8].Result}}</span>
              <span :class="whoscored(8, 2)">{{getteams($store.state.game.Match[8].AwayTeam)}}</span>
              <span><img :src="getimg($store.state.game.Match[8].AwayTeam)" alt=""></span>
            </div>
          </td>
          <td :class="classGet(8 , 'win')" v-if="$store.state.gameresult">
            <p>{{getbet(results[8].Result, "Main", 8).bet}}</p>
            <p>{{getbet(results[8].Result, "Main", 8).name}}</p>
          </td>
          <td :class="classGet(8 , 'win')" v-if="$store.state.gameresult">
            <p>{{$store.state.game.Match[8].Odds[results[8].Result]}}</p>
            <p>{{results[8].Result}}</p>
          </td>
          <td :class="classGet(8 , 'win')" v-if="$store.state.gameresult">
            <p>{{getbet(results[8].Result, "Double", 8).bet}}</p>
            <p>{{getbet(results[8].Result, "Double", 8).name}}</p>
          </td>
          <td :class="classGet(8 , 'win')" v-if="$store.state.gameresult">
            <p>{{getbet(results[8].Result, "Double", 8).bet2}}</p>
            <p>{{getbet(results[8].Result, "Double", 8).name2}}</p>
          </td>
          <td :class="getClass(getbet(results[8].Result, 'GGNG', 8).class)" v-if="$store.state.gameresult">
            <p>{{getbet(results[8].Result, "GGNG", 8).bet}}</p>
            <p>{{getbet(results[8].Result, "GGNG", 8).name}}</p>
          </td>
          <td :class="classGet(8 , 'win')" v-if="$store.state.gameresult">
            <p>{{getbet(results[8].Result, "GOALS", 8).bet}}</p>
            <p>{{getbet(results[8].Result, "GOALS", 8).name}}</p>
          </td>
          <td :class="getClass(getbet(results[8].Result, '1.5', 8).class)" v-if="$store.state.gameresult">
            <p>{{getbet(results[8].Result, 1.5, 8).bet}}</p>
            <p>{{getbet(results[8].Result, 1.5, 8).name}}</p>
          </td>
          <td :class="getClass(getbet(results[8].Result, '2.5', 8).class)" v-if="$store.state.gameresult">
            <p>{{getbet(results[8].Result, 2.5, 8).bet}}</p>
            <p>{{getbet(results[8].Result, 2.5, 8).name}}</p>
          </td>
          <td :class="getClass(getbet(results[8].Result, '3.5', 8).class)" v-if="$store.state.gameresult">
            <p>{{getbet(results[8].Result, 3.5, 8).bet}}</p>
            <p>{{getbet(results[8].Result, 3.5, 8).name}}</p>
          </td>
          <td :class="getClass(getbet(results[8].Result, '4.5', 8).class)" v-if="$store.state.gameresult">
            <p>{{getbet(results[8].Result, 4.5, 8).bet}}</p>
            <p>{{getbet(results[8].Result, 4.5, 8).name}}</p>
          </td>
        </tr>
        <tr class="trSeparator-2">
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>

        <tr class="trBg-2">
          <td :class="classGet(9 , 'teams')">
            <div>
              <span>10</span>
              <span><img :src="getimg($store.state.game.Match[9].HomeTeam)" alt=""></span>
              <span :class="whoscored(9, 0)">{{getteams($store.state.game.Match[9].HomeTeam)}}</span>
              <span v-if="$store.state.gameresult">{{results[9].Result}}</span>
              <span :class="whoscored(9, 2)">{{getteams($store.state.game.Match[9].AwayTeam)}}</span>
              <span><img :src="getimg($store.state.game.Match[9].AwayTeam)" alt=""></span>
            </div>
          </td>
          <td :class="classGet(9, 'win')" v-if="$store.state.gameresult">
            <p>{{getbet(results[9].Result, "Main", 9).bet}}</p>
            <p>{{getbet(results[9].Result, "Main", 9).name}}</p>
          </td>
          <td :class="classGet(9, 'cs')" v-if="$store.state.gameresult">
            <p>{{$store.state.game.Match[9].Odds[results[9].Result]}}</p>
            <p>{{results[9].Result}}</p>
          </td>
          <td :class="classGet(9, 'win')" v-if="$store.state.gameresult">
            <p>{{getbet(results[9].Result, "Double", 9).bet}}</p>
            <p>{{getbet(results[9].Result, "Double", 9).name}}</p>
          </td>
          <td :class="classGet(9, 'win')" v-if="$store.state.gameresult">
            <p>{{getbet(results[9].Result, "Double", 9).bet2}}</p>
            <p>{{getbet(results[9].Result, "Double", 9).name2}}</p>
          </td>
          <td :class="getClass(getbet(results[9].Result, 'GGNG', 9).class)" v-if="$store.state.gameresult">
            <p>{{getbet(results[9].Result, "GGNG", 9).bet}}</p>
            <p>{{getbet(results[9].Result, "GGNG", 9).name}}</p>
          </td>
          <td :class="classGet(9, 'goals')" v-if="$store.state.gameresult">
            <p>{{getbet(results[9].Result, "GOALS", 9).bet}}</p>
            <p>{{getbet(results[9].Result, "GOALS", 9).name}}</p>
          </td>
          <td :class="getClass(getbet(results[9].Result, '1.5', 9).class)" v-if="$store.state.gameresult">
            <p>{{getbet(results[9].Result, 1.5, 9).bet}}</p>
            <p>{{getbet(results[9].Result, 1.5, 9).name}}</p>
          </td>
          <td :class="getClass(getbet(results[9].Result, '2.5', 9).class)" v-if="$store.state.gameresult">
            <p>{{getbet(results[9].Result, 2.5, 9).bet}}</p>
            <p>{{getbet(results[9].Result, 2.5, 9).name}}</p>
          </td>
          <td :class="getClass(getbet(results[9].Result, '3.5', 9).class)" v-if="$store.state.gameresult">
            <p>{{getbet(results[9].Result, 3.5, 9).bet}}</p>
            <p>{{getbet(results[9].Result, 3.5, 9).name}}</p>
          </td>
          <td :class="getClass(getbet(results[9].Result, '4.5', 9).class)" v-if="$store.state.gameresult">
            <p>{{getbet(results[9].Result, 4.5, 9).bet}}</p>
            <p>{{getbet(results[9].Result, 4.5, 9).name}}</p>
          </td>
        </tr>
        <tr class="trSeparator-2">
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>

      </table>
      
    </div>

  </div>
  <!-- main STOP -->



  
</body>
</template>

<script>
import Cookies from 'js-cookie'
import countdown from '@/components/tvcountdown.js'

export default {
  name: 'TV2',
  timer: 0,
  mixins: [countdown],
  data: ()=>{
      return {
        results: [{Result: '0-0'}, {Result: '0-0'}, {Result: '0-0'}, {Result: '0-0'}, {Result: '0-0'}, {Result: '0-0'}, {Result: '0-0'}, {Result: '0-0'}, {Result: '0-0'}, {Result: '0-0'}],
        oldresults: [{Result: '0-0'}, {Result: '0-0'}, {Result: '0-0'}, {Result: '0-0'}, {Result: '0-0'}, {Result: '0-0'}, {Result: '0-0'}, {Result: '0-0'}, {Result: '0-0'}, {Result: '0-0'}],
        goalcount: 0,
        classanimation: '',
        timers: 0,
      }
    },

    computed: {
    game(){
      if(!this.$store.state.game) return
      let game = { time: {min: '', sec: ''}, count: '', date: ""};
      game.date = new Date();
      let time = this.$store.state.Time
      game.time.min = this.timers;
      game.count = this.$store.state.Time;
      game.time.min = game.time.min.toString();
      return game;
    }
  },
  watch: {
    'game.count'(count) {
      if(count < 2 && this.$store.state.jackpotlast.GameID == this.$store.state.game.GameID && this.timers == "FT"){
        this.$router.push({name: 'Jackpot', params: {Token: this.$route.params.Token}});
      }else if(this.$store.state.Time > 60 ){
        window.location.assign("/TV/" + this.$route.params.lang + "/" + this.$route.params.Token);
        //this.$router.push({name: 'TV'});
      }
    }
  },
  created: function () {
    this.$i18n.locale = this.$route.params.lang;
    this.$store.dispatch('apirequest', {token: 0, name: "jackpot/"+this.$route.params.Token});
    this.$store.dispatch('apirequest', {token: 0, name: "jackpot/last/"+this.$route.params.Token});
    this.$store.dispatch('apirequest', {token: 0, name: "game/"}).then((response) => {
          this.$store.state.Time = (this.$store.state.game.Time - Date.now()) / 1000;
        });
    this.$store.dispatch('apirequest', {token: 0, name: "game/result"});
    this.$store.dispatch('apirequest', {token: 0, name: "teams/"}).then(()=>{
      this.$store.state.teams.sort((a, b) => a.Score - b.Score).reverse()
    });
    if(this.$store.state.gameresult){
              for(let i = 0; i < 10; i++){
                this.goalcount += parseInt(this.$store.state.gameresult[i].Result[0])
                this.goalcount += parseInt(this.$store.state.gameresult[i].Result[2])
              }
            } 
  },
  destroyed() {
      clearInterval(this.$options.timer);
    },
  methods: {
    whoscored(index, pos){
      if(this.oldresults[index].Result != this.results[index].Result){
        setTimeout(()=>{
          this.oldresults[index].Result = this.results[index].Result
        }, 3000)
        if(this.oldresults[index].Result[pos] != this.results[index].Result[pos]){
          return 'backlight'
        }
      }
    },
    getClass(name){
      if(this.timers == "FT"){
        return 'change'
      }
      if(name == "GG" || name == "Over"){
        return "change2"
      }
    },
    classGet(index, name){
      if(this.timers == "FT" && name != 'teams'){
        return 'change'
      }
      if(this.oldresults[index].Result != this.results[index].Result){
        setTimeout(()=>{
          this.oldresults[index].Result = this.results[index].Result
        }, 3000)
        return "change"      
      }
      return
    },
    countDownTimer() {
      if(!this.$store.state.game) return
        if(this.$store.state.Time >= 0) {
          if(!this.$options.timer){          
            this.$options.timer = setInterval(() => {
              let chnc = Math.random();
              if(this.timers < 35){
                if(chnc < 0.3){
                  this.GetResults();
                }
              }else if(this.timers > 35 && this.timers < 75){
                if(chnc < 0.4){
                  this.GetResults();
                }
              }else{
                this.GetResultsFinal();
              }
              this.$store.state.Time -= 0.5;
              if(this.timers < 90){
                this.timers += 1
              }else{
                this.timers = "FT"
              }
              
            }, 500)
          }
        }else{
          this.$store.dispatch('apirequest', {token: 0, name: "game/"}).then((response) => {
            this.$store.state.Time = (this.$store.state.game.Time - Date.now()) / 1000;
          });
        }
    },
    GetResultsFinal(){
      let num = 3;
      for(let i = 0; i < 10; i++){
        let result1 = parseInt(this.results[i].Result[0]);
        let result2 = parseInt(this.results[i].Result[2]);
        if(num == 0) return
        if(this.$store.state.gameresult[i].Result[0] > this.results[i].Result[0]){
            this.results[i].Result = (result1 + 1) +'-'+result2;
            num -= 1;
            this.goalcount -= 1;
            i = 0;
          }else if (this.$store.state.gameresult[i].Result[2] > this.results[i].Result[2]){
            this.results[i].Result = result1 +'-'+(result2 + 1);
            num -= 1;
            this.goalcount -= 1;
            i = 0;
          }
      }
    },
    GetResults(){
      let num = 1;
      for(let i = 0; i < 100; i++){
        if(num > 0){
          let wini = parseInt(Math.random()*10);
          let chance = Math.random();
          let result1 = parseInt(this.results[wini].Result[0]);
          let result2 = parseInt(this.results[wini].Result[2]);
          if(chance < 0.5){
            if(this.$store.state.gameresult[wini].Result[0] > this.results[wini].Result[0]){
              this.results[wini].Result = (result1 + 1) +'-'+result2;
              this.goalcount -= 1;
              return
            }else if (this.$store.state.gameresult[wini].Result[2] > this.results[wini].Result[2]){
              this.results[wini].Result = result1 +'-'+(result2 + 1);
              this.goalcount -= 1;
              return
            }
          }else{
            if(this.$store.state.gameresult[wini].Result[2] > this.results[wini].Result[2]){
              this.results[wini].Result = result1 +'-'+(result2 + 1);
              this.goalcount -= 1;
              return
            }else if (this.$store.state.gameresult[wini].Result[0] > this.results[wini].Result[0]){
              this.results[wini].Result = (result1 + 1) +'-'+result2;
              this.goalcount -= 1;
              return
            }
          }
        }
      }
    },
    getteams(team){
      let result = this.$store.state.teams.filter(item => item.id == team);
      return result[0].Abriviation
    },
    getimg(name){
      if(name == null) return
      let result = this.$store.state.teams.filter(item => item.id == name);
      if(result[0].Icon != ""){
        return "https://champs-admin.info/gallery/" + result[0].Icon
      }
    },
    getbet(result, name, index){
      let total = parseInt(result[0]) + parseInt(result[2]);

      if(name == "Main"){
        if(result[0] > result[2]){
          return {name: "1", bet: this.$store.state.game.Match[index].Odds['1']}
        }else if(result[0] < result[2]){
          return {name: "2", bet: this.$store.state.game.Match[index].Odds['2']}
        }else{
          return {name: "X", bet: this.$store.state.game.Match[index].Odds['X']}
        }
      }

      if(name == "Double"){
        if(result[0] > result[2]){
          return {name: "1X", bet: this.$store.state.game.Match[index].Odds['1X'], name2: "12", bet2: this.$store.state.game.Match[index].Odds['12']}
        }else if(result[0] < result[2]){
          return {name: "X2", bet: this.$store.state.game.Match[index].Odds['X2'], name2: "12", bet2: this.$store.state.game.Match[index].Odds['12']}
        }else{
          return {name: "1X", bet: this.$store.state.game.Match[index].Odds['1X'], name2: "X2", bet2: this.$store.state.game.Match[index].Odds['X2']}
        }
      }

      if(name == "GGNG"){
        if(result[0] > 0 && result[2] > 0){
          return {name: this.$t('gg'), bet: this.$store.state.game.Match[index].Odds['GG'], class: "GG"}
        }else{
          return {name: this.$t('ng'), bet: this.$store.state.game.Match[index].Odds['NG']}
        }
      } 

      if(name == "GOALS"){
        if(total == 0){
          return {name: "0", bet: "0"}
        }else{
          return {name: total, bet: this.$store.state.game.Match[index].Odds['Goals('+total+')']}
        }
      }

      if(total > name){
        return {name: this.$t('ov')+name, bet: this.$store.state.game.Match[index].Odds['Over('+name+')'], class: "Over"}
      }else{
        return {name: this.$t('un')+name, bet: this.$store.state.game.Match[index].Odds['Under('+name+')']}
      }     
    },
  }
};
</script>

<style>
.change {
  background-color: #ff7f50;
}

.change2 {
  background-color: #ff7f59;
}

.backlight {
  text-shadow: 
  -0   -3px 0   #FFFF00,
  0   -3px 0   #FFFF00,
 -0    3px 0   #FFFF00,
  0    3px 0   #FFFF00,
 -3px -0   0   #FFFF00,
  3px -0   0   #FFFF00,
 -3px  0   0   #FFFF00,
  3px  0   0   #FFFF00,
 -1px -3px 0   #FFFF00,
  1px -3px 0   #FFFF00,
 -1px  3px 0   #FFFF00,
  1px  3px 0   #FFFF00,
 -3px -1px 0   #FFFF00,
  3px -1px 0   #FFFF00,
 -3px  1px 0   #FFFF00,
  3px  1px 0   #FFFF00,
 -2px -3px 0   #FFFF00,
  2px -3px 0   #FFFF00,
 -2px  3px 0   #FFFF00,
  2px  3px 0   #FFFF00,
 -3px -2px 0   #FFFF00,
  3px -2px 0   #FFFF00,
 -3px  2px 0   #FFFF00,
  3px  2px 0   #FFFF00,
 -3px -3px 0   #FFFF00,
  3px -3px 0   #FFFF00,
 -3px  3px 0   #FFFF00,
  3px  3px 0   #FFFF00,
 -3px -3px 0   #FFFF00,
  3px -3px 0   #FFFF00,
 -3px  3px 0   #FFFF00,
  3px  3px 0   #FFFF00;
}

</style>